import { Modal } from "antd";
import { useEffect, useRef } from "react";
import styled from "styled-components";
import Header from "./Header";

const Style = styled.div`
  max-height: 400px;
  overflow-y: auto;

  .item {
    border-bottom: 1px solid #E5E7EB;
    padding: var(--size) 0;

    &:first-child {
      padding-top: 0;
    }

    h1 {
      font-size: var(--font-size-lg);
      font-weight: 600;
      color: #001529;
      margin-bottom: 4px;
    }
    p {
      color: #667085;
      font-weight: 500;
      font-size: 14px;
      margin-bottom: 0px;
    }
  }
`;

export default function KycModal({ activeCheck, onCancel, data = [] }) {
  const ref = useRef();

  useEffect(() => {
    if (activeCheck) {
      setTimeout(() => {
        const _el = document.getElementById(`kyc-checks-${activeCheck.index}`);
        if (_el) {
          const top = _el.offsetTop;
          ref.current.scrollTo({
            top: top - 131,
            behavior: 'smooth',
          });
        }
      }, 300);
    }
  }, [activeCheck])

  return (
    <Modal
      open={!!activeCheck}
      onCancel={onCancel}
      footer={null}
      title={<Header />}
      width={630}
      className="custom-modal"
      destroyOnClose
    >
      <Style ref={ref}>
        {data.map((item, i) => (
          <div id={`kyc-checks-${i + 1}`} className="item" key={`item-${i}-${item.title}`}>
            <h1>{item.title}</h1>
            <p>{item.challengeText}</p>
          </div>
        ))}

      </Style>
    </Modal>
  )
}
